import { render, staticRenderFns } from "./EditToppingMenu.vue?vue&type=template&id=e7520fd4&scoped=true&"
import script from "./EditToppingMenu.vue?vue&type=script&lang=js&"
export * from "./EditToppingMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditToppingMenu.vue?vue&type=style&index=0&id=e7520fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7520fd4",
  null
  
)

export default component.exports